import React from "react";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import { AppBarButtonActive } from "../TaxGuruStyles";

export type NavigationButtonProps = {
    link: string;
    title: string;
};

const NavigationDesktopButton = ({ title, link }: NavigationButtonProps) => {
    const location = useLocation();

    const active = location.pathname === link ? true : location.pathname.startsWith(link) && link !== "/";

    return (
        <Button
            component={Link}
            to={link}
            size="medium"
            variant="text"
            sx={(theme) => ({
                color: theme.palette.text.secondary,
                fontWeight: 500,
                px: 1.5,
                "&:hover": {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.action.hover,
                },
                ...(active && {
                    fontWeight: 600,
                    color: theme.palette.primary.main,
                    backgroundColor: AppBarButtonActive,
                    "&:hover": { backgroundColor: AppBarButtonActive },
                }),
                display: "block",
            })}
        >
            {title}
        </Button>
    );
};

export default NavigationDesktopButton;
